import type {AssortmentItem, AssortmentType} from '../../../../types';
import type {BadgeColor} from '@ds/components';

import {BarChartOutlined, DatabaseOutlined, TagsOutlined} from '@ant-design/icons';
import {Badge, Card, Divider} from '@ds/components';
import {numberFormat} from 'utils/Helper';

import {ASSORTMENT_STATUS_LABELS} from '../../../../constants';

type AssortmentListItemProps = {
  item: AssortmentItem;
  assortmentType: AssortmentType;
  onStatusClick: () => void;
  onDetailsClick: () => void;
};

const AssortmentListItem: React.FC<AssortmentListItemProps> = ({
  item,
  assortmentType,
  onStatusClick,
  onDetailsClick
}) => {
  const statusLabel = ASSORTMENT_STATUS_LABELS[item.status];
  const statusColor: BadgeColor =
    item.status === 'Available'
      ? 'success'
      : item.status === 'OutOfStock' || item.status === 'Ugly'
        ? 'error'
        : item.status === 'Critical'
          ? 'warning'
          : 'neutral';

  return (
    <Card size="small" className="w-full" bordered={false}>
      <article className="flex items-center gap-3">
        <div className="flex size-18.75 shrink-0 items-center justify-center">
          <img
            className="size-full object-contain"
            src={item.product_image_url}
            alt={item.product_title ?? ''}
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <span className="truncate text-body-xs-emphasis text-gray-08">{item.product_title}</span>
          <div className="flex items-center justify-between gap-2">
            <button
              type="button"
              className="flex min-w-0 items-center gap-3 text-body-xs text-gray-07"
              onClick={onDetailsClick}
            >
              {assortmentType === 'assortment vendor' && (
                <>
                  <span className="flex items-center gap-1">
                    <BarChartOutlined className="text-gray-04" aria-hidden />
                    {item.weekly_avg}
                  </span>
                  <Divider type="vertical" height={11} />
                </>
              )}
              <span className="flex items-center gap-1">
                {assortmentType === 'assortment region' ? (
                  <TagsOutlined className="text-gray-04" aria-hidden />
                ) : (
                  <DatabaseOutlined className="text-gray-04" aria-hidden />
                )}
                {assortmentType === 'assortment region' ? (
                  <span>
                    {numberFormat(Number(item.avg_price ?? 0))}{' '}
                    <span className="text-field-caption">تومان</span>
                  </span>
                ) : (
                  numberFormat(item.stock ?? 0)
                )}
              </span>
            </button>
            {statusLabel && (
              <button type="button" className="shrink-0" onClick={onStatusClick}>
                <Badge variant="status" color={statusColor} size="md">
                  {statusLabel}
                </Badge>
              </button>
            )}
          </div>
        </div>
      </article>
    </Card>
  );
};

export default AssortmentListItem;
